// import React, { useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { AxiosResponse } from "axios";
// import { all_routes } from "../../router/all_routes";
// import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
// import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
// import { toast } from "react-toastify";
// import CommonSelect2 from "../../../core/common/commonSelect2";

// const UploadBulkLeads = () => {
//   const [loading, setLoading] = useState<any>([])
//   const routes = all_routes;

//   const chooseStatus = [
//     { value: "", label: "Select Source Type" },
//     { value: "active", label: "olx" },
//     { value: "resume", label: "magic bricks" },
//     { value: "suspended", label: "housings" },
//   ]

//   const downloadExcelFileData = async () => {
//     setLoading(true)
//     const response = await AXIOSCONFIGMETHOD(
//       "get",
//       webServiceUrl.DOWNLOAD_EXCEL_TEMPLATE,
//       null,
//       { responseType: "blob" }
//     );
//     if (response?.success && response.data?.length > 0) {
//       toast.success("Your Excel template is starting soon");
//       const blob = new Blob([response.data[0]]);
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.setAttribute("download", "template.xlsx");
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } else {
//       toast.error(`Failed to download template: ${response?.message || 'Unknown error'}`);
//       console.error("Failed to download template:", response?.message);
//     }
//     setLoading(false)
//   };


//   const downloadSampleExcelFileData = async () => {

//     try {
//       const response = await AXIOSCONFIGMETHOD(
//         "get",
//         webServiceUrl.DOWNLOAD_SAMPLE_TEMPLATE,
//         null,
//         {
//           responseType: "blob",
//         }
//       );
//       toast.success("Your excel template is starting soon");
//       if (!response?.success || !response?.data?.length) {
//         toast.error("Failed to download sample template.");
//         return;
//       }

//       // Create a Blob from the response data
//       const blob = new Blob([response.data[0]], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

//       // Create a download URL
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;

//       // Extract filename from Content-Disposition header
//       let fileName = "Sample_Template.xlsx";

//       const contentDisposition = (response as any)?.headers?.["content-disposition"];
//       if (contentDisposition && contentDisposition.includes("filename=")) {
//         const match = contentDisposition.match(/filename="?([^"]+)"?/);
//         if (match && match[1]) {
//           fileName = decodeURIComponent(match[1]);
//         }
//       }

//       link.setAttribute("download", fileName);
//       document.body.appendChild(link);
//       link.click();

//       // Cleanup
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("❌ Error downloading Excel file:", error);
//       toast.error("Something went wrong while downloading the sample file.");
//     }
//     setLoading(false)
//   };

//   const [selectedFile, setSelectedFile] = useState<File | null>(null);
//   //  const fileInputRef = useRef<HTMLInputElement>(null);
//   const [dragOver, setDragOver] = useState<boolean>(false);
//   const fileInputRef = useRef<HTMLInputElement>(null);


//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       validateAndSetFile(file);
//     }
//   };


//   const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
//     e.preventDefault();
//     setDragOver(false);
//     const file = e.dataTransfer.files[0];
//     if (file) {
//       validateAndSetFile(file);
//     }
//   };

//   const validateAndSetFile = (file: File) => {
//     const allowedTypes = [
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       "application/vnd.ms-excel",
//     ];
//     if (!allowedTypes.includes(file.type)) {
//       toast.error("Only .xlsx and .xls files are allowed.");
//       return;
//     }
//     setSelectedFile(file);
//   };

//   const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     if (!selectedFile) {
//       toast.error("Please select a file before uploading.");
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append("file", selectedFile);

//       const response = await AXIOSCONFIGMETHOD(
//         "post",
//         webServiceUrl.UPLOAD_BULK_LEADS,
//         formData,
//         {
//           "Content-Type": "multipart/form-data",
//         }
//       );

//       if (response?.success) {
//         toast.success("File uploaded successfully!");
//         // console.log("Uploaded response:", response.data);
//         setSelectedFile(null);
//         if (fileInputRef.current) {
//           fileInputRef.current.value = "";
//         }
//       } else {
//         toast.error(response?.message || "File upload failed.");
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       toast.error("Something went wrong while uploading the file.");
//     }
//   };



//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content">
//           {/* Breadcrumb */}
//           <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//             <div className="my-auto mb-2">
//               <h2 className="mb-1"> Upload Bulk Leads </h2>
//               <nav>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to={routes.adminDashboard}>
//                       <i className="ti ti-smart-home" />
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">
//                     <Link to={routes.leaddashboard}>Dashboard</Link>
//                   </li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Upload Bulk Leads
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//           </div>

//           {/* Upload Card */}
//           <div className="card1 mb-0">
//             <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
//               <h5 className="mb-0">Upload Bulk Leads</h5>

//               <div className="d-flex align-items-center flex-wrap mb-4 row-gap-3">
//                 {/* <button onClick={downloadExcelFileData} type="button" className="btn btn-outline-primary me-2">
//                   <i className="ti ti-download" />
//                   Download Template
//                 </button>
//                 <button onClick={downloadSampleExcelFileData} type="button" className="btn btn-outline-secondary">
//                   <i className="ti ti-download" />
//                   Download Sample Template
//                 </button> */}
//                 <CommonSelect2
//                   options={[
//                     { value: "1", label: "OLX" },
//                     { value: "2", label: "Magic Bricks" },
//                     { value: "3", label: "Housing" }
//                   ]}
//                   // placeholder={"Select Source Type"}
//                   styles={{ "textAlign": "center"}}
//                   defaultValue=""
//                 />

//               </div>
//             </div>

//             <div className="card-body">
//               <form onSubmit={handleSubmit}>
//                 <label
//                   htmlFor="bulkLeadsFile"
//                   className={`upload-dropzone ${dragOver ? "drag-over" : ""}`}
//                   onDragOver={(e) => {
//                     e.preventDefault();
//                     setDragOver(true);
//                   }}
//                   onDragLeave={() => setDragOver(false)}
//                   onDrop={handleDrop}
//                 >
//                   <i className="ti ti-upload" />
//                   {selectedFile ? (
//                     <div style={{ fontWeight: "bold", textAlign: "center" }}>
//                       📄 {selectedFile.name}
//                     </div>
//                   ) : (
//                     <>
//                       <h6>Drag & drop your file here</h6>
//                       <p>or click to select a file</p>
//                     </>
//                   )}
//                   <input
//                     type="file"
//                     accept=".xlsx, .xls"
//                     onChange={handleFileChange}
//                     id="bulkLeadsFile"
//                     name="bulkLeads"
//                     ref={fileInputRef}
//                     style={{ display: "none" }}
//                   />
//                 </label>

//                 <div className="text-end mt-4">
//                   <button type="submit" className="upload-submit-btn">
//                     <i className="ti ti-cloud-upload" /> Upload
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>

//         </div>



//         <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
//           <p className="mb-0">{new Date().getFullYear()} © Nestfin Technology. All rights reserved.</p>
//         </div>
//       </div>


//       <style>
//         {`

//         .upload-dropzone {
//   border: 2px dashed #ccc;
//   border-radius: 6px;
//   padding: 40px;
//   text-align: center;
//   cursor: pointer;
//   position: relative;
//   transition: border-color 0.2s ease;
// }

// .upload-dropzone.drag-over {
//   border-color: #007bff;
//   background-color: #f0f8ff;
// }

// .upload-dropzone input[type="file"] {
//   display: none;
// }

//   /* --- GENERAL RESET --- */
//   * {
//     box-sizing: border-box;
//   }

//   /* --- PAGE WRAPPER --- */
//   .page-wrapper {
//     background-color: #f4f7fa;
//     min-height: 100vh;
//     display: flex;
//     flex-direction: column;
//   }

//   .content {
//     flex-grow: 1;
//     padding: 2rem 3rem;
//     width: 100%;
//     margin: 0 auto;
//     max-width: 1200px;
//   }

//   h2, h5 {
//     font-weight: 700;
//     color: #1f2937;
//     letter-spacing: 0.02em;
//   }

//   /* --- BREADCRUMB --- */
//   .breadcrumb {
//     background: transparent;
//     padding: 0;
//     margin-bottom: 0;
//     font-weight: 500;
//     color: #6b7280;
//   }

//   .breadcrumb-item + .breadcrumb-item::before {
//     content: ">";
//     margin: 0 0.5rem;
//     color: #9ca3af;
//   }

//   /* --- CARD --- */
//   .card1 {
//     background: #fff;
//     border-radius: 18px;
//     box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
//     padding: 2rem;
//     margin-bottom: 3rem;
//     width: 100%;
//     transition: box-shadow 0.3s ease;
//   }

//   .card1:hover {
//     box-shadow: 0 20px 48px rgba(0, 0, 0, 0.15);
//   }

//   .card1-header {
//     display: flex;
//     flex-wrap: wrap;
//     align-items: center;
//     justify-content: space-between;
//     gap: 1rem;
//     margin-bottom: 1.5rem;
//   }

//   .card1-header h5 {
//     font-size: 1.2rem;
//     margin: 0;
//   }

//   /* --- BUTTONS --- */
//   .btn-outline-primary,
//   .btn-outline-secondary {
//     border-radius: 8px;
//     font-weight: 500;
//     padding: 0.35rem 1.2rem;
//     font-size: 0.9rem;
//     display: flex;
//     align-items: center;
//     gap: 0.4rem;
//     transition: all 0.3s ease;
//     cursor: pointer;
//     border-width: 2px;
//     background-color: transparent;
//     border-style: solid;
//     user-select: none;
//   }

//   .btn-outline-primary {
//     color: #014d4e;
//     border-color: #2563eb;
//   }

//   .btn-outline-primary:hover {
//     background-color: #2563eb;
//     color: white;
//     box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);
//     transform: translateY(-2px);
//   }

//   .btn-outline-secondary {
//     color: #6b7280;
//     border-color: #6b7280;
//   }

//   .btn-outline-secondary:hover {
//     background-color: #6b7280;
//     color: white;
//     box-shadow: 0 8px 20px rgba(107, 114, 128, 0.35);
//     transform: translateY(-2px);
//   }

//   /* --- DROPZONE --- */
//   .upload-dropzone {
//     position: relative;
//     border: 2px dashed #9ca3af;
//     border-radius: 16px;
//     background-color: #fefefe;
//     padding: 2rem;
//     text-align: center;
//     cursor: pointer;
//     transition: border-color 0.3s ease, box-shadow 0.3s ease;
//     overflow: hidden;
//     box-shadow: 0 8px 20px rgba(156, 163, 175, 0.15);
//     user-select: none;
//     width: 100%;
//     min-height: 200px;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//   }

//   .upload-dropzone:hover {
//     border-color: #014d4e;
//     box-shadow: 0 12px 32px rgba(37, 99, 235, 0.35);
//   }

//   .upload-dropzone i {
//     font-size: 2rem;
//     color: #014d4e;
//     margin-bottom: 1rem;
//   }

//   .upload-dropzone h6 {
//     font-size: 1.2rem;
//     margin-bottom: 0.4rem;
//   }

//   .upload-dropzone p {
//     font-size: 1rem;
//     color: #014d4e;
//     margin: 0;
//   }

//   .upload-dropzone::before {
//     content: "";
//     position: absolute;
//     top: 0;
//     left: -60%;
//     width: 50%;
//     height: 100%;
//     background: linear-gradient(
//       45deg,
//       rgba(255, 255, 255, 0) 30%,
//       rgba(255, 255, 255, 0.55) 50%,
//       rgba(255, 255, 255, 0) 70%
//     );
//     transform: skewX(-25deg);
//     pointer-events: none;
//     opacity: 0;
//     transition: opacity 0.5s ease;
//     z-index: 2;
//   }

//   .upload-dropzone:hover::before {
//     animation: shine-slide 2s linear infinite;
//     opacity: 1;
//   }

//   @keyframes shine-slide {
//     0% {
//       left: -60%;
//     }
//     100% {
//       left: 150%;
//     }
//   }

//   input[type="file"] {
//     display: none;
//   }

//   .upload-submit-btn {
//     background-color: #014d4e;
//     color: white;
//     font-weight: 500;
//     padding: 0.45rem 1.5rem;
//     font-size: 1rem;
//     border-radius: 6px;
//     border: none;
//     box-shadow: 0 8px 24px rgba(37, 99, 235, 0.35);
//     cursor: pointer;
//     transition: background-color 0.3s ease, box-shadow 0.3s ease,
//       transform 0.2s ease;
//     user-select: none;
//     display: inline-flex;
//     align-items: center;
//     gap: 0.5rem;
//   }

//   .upload-submit-btn:hover {
//     background-color: #013f3f;
//     transform: translateY(-2px);
//     box-shadow: 0 12px 32px rgba(29, 78, 216, 0.5);
//   }

//   /* --- FOOTER --- */
//   .footer {
//     background-color: white;
//     padding: 1rem 3rem;
//     border-top: 1px solid #e5e7eb;
//     display: flex;
//     justify-content: space-between;
//     flex-wrap: wrap;
//     font-size: 0.9rem;
//     color: #6b7280;
//     user-select: none;
//   }

//   .footer a {
//     color: #2563eb;
//     text-decoration: none;
//     font-weight: 600;
//     transition: color 0.3s ease;
//   }

//   .footer a:hover {
//     color: #1d4ed8;
//   }

//   /* --- RESPONSIVE --- */
//   @media (max-width: 768px) {
//     .content {
//       padding: 1.5rem;
//     }

//     .card1 {
//       padding: 1.5rem;
//     }

//     .card-header {
//       flex-direction: column;
//       align-items: flex-start;
//     }

//     .d-flex.align-items-center.flex-wrap.row-gap-3 {
//       flex-direction: column;
//       align-items: stretch;
//       gap: 0.75rem;
//     }

//     .upload-submit-btn {
//       width: 100%;
//       justify-content: center;
//     }

//     .upload-dropzone {
//       padding: 1.5rem;
//       min-height: 180px;
//     }

//     .upload-dropzone h6 {
//       font-size: 1rem;
//     }

//     .upload-dropzone p {
//       font-size: 0.95rem;
//     }
//   }
//   `}
//       </style>

//     </>
//   );
// };

// export default UploadBulkLeads;


import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import { toast } from "react-toastify";
import CommonSelect2 from "../../../core/common/commonSelect2";

type Option = {
  label: string;
  value: string;
};

interface SelectProps {
  options: Option[];
  defaultValue?: Option | null;
  value?: Option | null;     // <-- ADD THIS
  onChange?: (option: Option | null) => void;
}

const UploadBulkLeads: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [dragOver, setDragOver] = useState(false);
  const [selectedSource, setSelectedSource] = useState(""); // track source type

  const fileInputRef = useRef<HTMLInputElement>(null);
  const routes = all_routes;
  const leadOptions = [
    { value: "leads_data", label: "leads data" },
    { value: "olx-leads", label: "olx-leads" },
    { value: "response", label: "response" },
    // { value: "leads_data", label: "OLX" },
    // { value: "olx-leads", label: "Magic Bricks" },
    // { value: "response", label: "Housing" },
  ];
  const validateAndSetFile = (file: File) => {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only .xlsx and .xls files are allowed.");
      return;
    }
    setSelectedFile(file);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) validateAndSetFile(file);
  };

  const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) validateAndSetFile(file);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!selectedFile) {
      toast.error("Please select a file before uploading.");
      return;
    }

    if (!selectedSource) {
      toast.error("Please select a source type before uploading.");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("sheet", selectedFile);
      formData.append("sheet_type", selectedSource);

      console.log(formData)
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.UPLOAD_BULK_LEADS,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response?.success) {
        toast.success("File uploaded successfully!");
        setSelectedFile(null);
        setSelectedSource("");
        if (fileInputRef.current) fileInputRef.current.value = "";
      } else {
        toast.error(response?.message || "File upload failed.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Something went wrong while uploading the file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Upload Bulk Leads</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.leaddashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Upload Bulk Leads
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          {/* Upload Card */}
          <div className="card1 mb-0">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5 className="mb-0">Upload Bulk Leads</h5>

              {/* <CommonSelect2
                options={[
                  { value: "leads_data", label: "OLX" },
                  { value: "olx-leads", label: "Magic Bricks" },
                  { value: "response", label: "Housing" },
                  // { value: "olx", label: "OLX" },
                  // { value: "magic_bricks", label: "Magic Bricks" },
                  // { value: "housing", label: "Housing" },
                ]}
                value={options.find((opt:any) => opt.value === selectedSource) || null}
                onChange={(option) => setSelectedSource(option.value)}
              /> */}
              <div className="d-flex align-items-center flex-wrap mb-4 row-gap-3">
              <CommonSelect2
                options={leadOptions}
                defaultValue={leadOptions.find(o => o.value === selectedSource) || null}
                onChange={(option) => setSelectedSource(option?.value || "")}
              />
              </div>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <label
                  htmlFor="bulkLeadsFile"
                  className={`upload-dropzone ${dragOver ? "drag-over" : ""}`}
                  onDragOver={(e) => {
                    e.preventDefault();
                    setDragOver(true);
                  }}
                  onDragLeave={() => setDragOver(false)}
                  onDrop={handleDrop}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <i className="ti ti-upload" />
                  {selectedFile ? (
                    <div style={{ fontWeight: "bold", textAlign: "center" }}>
                      📄 {selectedFile.name}
                    </div>
                  ) : (
                    <>
                      <h6>Drag & drop your file here</h6>
                      <p>or click to select a file</p>
                    </>
                  )}
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    style={{ display: "none" }}
                  />
                </label>

                <div className="text-end mt-4">
                  <button
                    type="submit"
                    className="upload-submit-btn"
                    disabled={loading}
                  >
                    <i className="ti ti-cloud-upload" />{" "}
                    {loading ? "Uploading..." : "Upload"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            {new Date().getFullYear()} © Nestfin Technology. All rights reserved.
          </p>
        </div>
      </div>
      <style>
        {`
        .upload-dropzone {
  border: 2px dashed #ccc;
  border-radius: 6px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s ease;
}
.upload-dropzone.drag-over {
  border-color: #007bff;
  background-color: #f0f8ff;
}
.upload-dropzone input[type="file"] {
  display: none;
}
  /* --- GENERAL RESET --- */
  * {
    box-sizing: border-box;
  }
  /* --- PAGE WRAPPER --- */
  .page-wrapper {
    background-color: #f4f7fa;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .content {
    flex-grow: 1;
    padding: 2rem 3rem;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
  }
  h2, h5 {
    font-weight: 700;
    color: #1f2937;
    letter-spacing: 0.02em;
  }
  /* --- BREADCRUMB --- */
  .breadcrumb {
    background: transparent;
    padding: 0;
    margin-bottom: 0;
    font-weight: 500;
    color: #6b7280;
  }
  .breadcrumb-item + .breadcrumb-item::before {
    content: ">";
    margin: 0 0.5rem;
    color: #9ca3af;
  }
  /* --- CARD --- */
  .card1 {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    margin-bottom: 3rem;
    width: 100%;
    transition: box-shadow 0.3s ease;
  }
  .card1:hover {
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.15);
  }
  .card1-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  .card1-header h5 {
    font-size: 1.2rem;
    margin: 0;
  }
  /* --- BUTTONS --- */
  .btn-outline-primary,
  .btn-outline-secondary {
    border-radius: 8px;
    font-weight: 500;
    padding: 0.35rem 1.2rem;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    transition: all 0.3s ease;
    cursor: pointer;
    border-width: 2px;
    background-color: transparent;
    border-style: solid;
    user-select: none;
  }
  .btn-outline-primary {
    color: #014d4e;
    border-color: #2563eb;
  }
  .btn-outline-primary:hover {
    background-color: #2563eb;
    color: white;
    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);
    transform: translateY(-2px);
  }
  .btn-outline-secondary {
    color: #6b7280;
    border-color: #6b7280;
  }
  .btn-outline-secondary:hover {
    background-color: #6b7280;
    color: white;
    box-shadow: 0 8px 20px rgba(107, 114, 128, 0.35);
    transform: translateY(-2px);
  }
  /* --- DROPZONE --- */
  .upload-dropzone {
    position: relative;
    border: 2px dashed #9ca3af;
    border-radius: 16px;
    background-color: #fefefe;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(156, 163, 175, 0.15);
    user-select: none;
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .upload-dropzone:hover {
    border-color: #014d4e;
    box-shadow: 0 12px 32px rgba(37, 99, 235, 0.35);
  }
  .upload-dropzone i {
    font-size: 2rem;
    color: #014d4e;
    margin-bottom: 1rem;
  }
  .upload-dropzone h6 {
    font-size: 1.2rem;
    margin-bottom: 0.4rem;
  }
  .upload-dropzone p {
    font-size: 1rem;
    color: #014d4e;
    margin: 0;
  }
  .upload-dropzone::before {
    content: "";
    position: absolute;
    top: 0;
    left: -60%;
    width: 50%;
    height: 100%;
    background: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.55) 50%,
      rgba(255, 255, 255, 0) 70%
    );
    transform: skewX(-25deg);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.5s ease;
    z-index: 2;
  }
  .upload-dropzone:hover::before {
    animation: shine-slide 2s linear infinite;
    opacity: 1;
  }
  @keyframes shine-slide {
    0% {
      left: -60%;
    }
    100% {
      left: 150%;
    }
  }
  input[type="file"] {
    display: none;
  }
  .upload-submit-btn {
    background-color: #014d4e;
    color: white;
    font-weight: 500;
    padding: 0.45rem 1.5rem;
    font-size: 1rem;
    border-radius: 6px;
    border: none;
    box-shadow: 0 8px 24px rgba(37, 99, 235, 0.35);
    cursor: pointer;
    transition: background-color 0.3s ease, box-shadow 0.3s ease,
      transform 0.2s ease;
    user-select: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .upload-submit-btn:hover {
    background-color: #013f3f;
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(29, 78, 216, 0.5);
  }
  /* --- FOOTER --- */
  .footer {
    background-color: white;
    padding: 1rem 3rem;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 0.9rem;
    color: #6b7280;
    user-select: none;
  }
  .footer a {
    color: #2563eb;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.3s ease;
  }
  .footer a:hover {
    color: #1d4ed8;
  }
  /* --- RESPONSIVE --- */
  @media (max-width: 768px) {
    .content {
      padding: 1.5rem;
    }
    .card1 {
      padding: 1.5rem;
    }
    .card-header {
      flex-direction: column;
      align-items: flex-start;
    }
    .d-flex.align-items-center.flex-wrap.row-gap-3 {
      flex-direction: column;
      align-items: stretch;
      gap: 0.75rem;
    }
    .upload-submit-btn {
      width: 100%;
      justify-content: center;
    }
    .upload-dropzone {
      padding: 1.5rem;
      min-height: 180px;
    }
    .upload-dropzone h6 {
      font-size: 1rem;
    }
    .upload-dropzone p {
      font-size: 0.95rem;
    }
  }
  `}
      </style>
    </>
  );
};

export default UploadBulkLeads;


